export default "__VITE_ASSET__BPlZLXa___"